import React from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { App, Button, Card, Space } from 'antd';
import { MenuOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import PageHeader from 'components/headings/PageHeader';
import MenuItemsContent from 'pages/liftlogic/v2/MenuItems/MenuItemsContent';

// Vista del super-tenant (liftlogic) para editar los menu_items de un tenant
// especifico. Accedida desde TenantEditPage → boton "Menu". Replica el
// patron de TenantPdfTemplatesPage: recibe tenantId del path y pasa al
// componente compartido MenuItemsContent.
function TenantMenuItemsPage() {
  const { tenantId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const tenantName = location.state?.tenantName || `Tenant ${tenantId}`;

  return (
    <App>
      <div style={{ padding: 16 }}>
        <PageHeader
          icon={MenuOutlined}
          title="Menú del tenant"
          subtitle={`Tenant: ${tenantName}`}
          actions={
            <Space>
              <Button
                icon={<ArrowLeftOutlined />}
                onClick={() =>
                  navigate(`/admin/tenants/${tenantId}/edit`, {
                    state: location.state,
                  })
                }
              >
                Volver al tenant
              </Button>
            </Space>
          }
        />
        <Card>
          <MenuItemsContent tenantId={Number(tenantId)} />
        </Card>
      </div>
    </App>
  );
}

export default TenantMenuItemsPage;
